import { IonToolbar,IonHeader,IonTitle,IonButtons,IonMenuButton, IonText, IonImg } from "@ionic/react"
import './Ae2Header.css'
import WhiteIcon from '../../assets/AlphaSecondaryLogo_White.png'

const Ae2Header: React.FC = () => {


    const handleClick = () =>{
      window.location.href = '/'
    }

    return (
      <>
        <IonHeader translucent={true}>
              <IonToolbar className='top-header'>
                <IonTitle className='mobile-title' onClick={e => handleClick()}>Alpha Insights</IonTitle>
                <IonTitle className='pc-title'>
                  <IonText className="pc-title-content" onClick={e => handleClick()}> Alpha Controls & Services Insights</IonText>
                  {/* <AE2Icon className="header-logo" /> */}
                  <IonImg src={WhiteIcon} className="header-logo" onClick={() => handleClick()}/>
                </IonTitle>
                <IonButtons slot="end">
                    <IonMenuButton />
                  </IonButtons>
              </IonToolbar>
          </IonHeader>
      </>
    )
}

export default Ae2Header